import { render, staticRenderFns } from "./FilepondTranslated.vue?vue&type=template&id=5c5cf7b6&scoped=true&"
import script from "./FilepondTranslated.vue?vue&type=script&lang=js&"
export * from "./FilepondTranslated.vue?vue&type=script&lang=js&"
import style0 from "./FilepondTranslated.vue?vue&type=style&index=0&id=5c5cf7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5cf7b6",
  null
  
)

export default component.exports